
import { getCollectionApi } from "dbApi";
const collection = 'FireMail';

export function sendEmail(to, subject, text, bodyHtml) {
    console.log('sendEmail')
    let toArray = Array.isArray(to) ? to : [to];
    let msg = {
        subject: subject,
        text: text,
    }
    let email = {
        to: toArray,
        message: msg
    }
    if (bodyHtml) {
        msg.html = bodyHtml;
    }

    return new Promise((resolve, reject) => {
        getCollectionApi(collection).add(email)
            .then(() => {
                resolve(true);
            })
            .catch((error) => {
                console.error("Error sending email: ", error);
                reject(error);
            });
    });
}
